import React from "react";
import logo from "../../assets/logo-2x.png";
import { HamburgerIcon } from "./SvgIcons";
import { ProfileDropdown } from "./ProfileDropdown";
import { NotificationCenter } from "./NotificationCenter";
import UserGuideController from "./UserGuideController";

export function TopHeader({
	children,
	user,
	onLogout,
	permissions,
	notifications,
}) {
	const toggleSidebar = () => {
		window.dispatchEvent(new CustomEvent("sidebar-toggle"));
	};

	return (
		<header className="top-header">
			<button
				className="sidebar-toggle-btn"
				onClick={toggleSidebar}
				aria-label="Toggle menu">
				<HamburgerIcon size={20} />
			</button>
			<div className="top-header-logo">
				<img src={logo} alt="RedAwning" />
			</div>
			<div className="th-actions">
				{children}
				<UserGuideController />
				<NotificationCenter notifications={notifications} />
				<ProfileDropdown
					user={user}
					onLogout={onLogout}
					permissions={permissions}
				/>
			</div>
		</header>
	);
}

export default TopHeader;
